import React from 'react';
import { Card, CardContent, Typography, Button, Grid, Divider, Box } from '@mui/material';
import UserHeader from '../UserComponent/UserHeader';
import failed_icon from "../../images/failed_icon.png";
import payCallIcon from "../../images/payCallIcon.png";
import payEmailIcon from "../../images/payEmailIcon.png";
import { useLocation, useNavigate } from 'react-router-dom';

export const Failed = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { package: selectedPackage, payment_id } = location.state || {};
    const email = localStorage.getItem('email');
    React.useEffect(() => {
        if (!selectedPackage || !payment_id) {
            navigate('/upgrade');
        }
    }, [navigate, selectedPackage, payment_id]);

    return (
        <div>
            <UserHeader />
            <Box sx={{ px: 2 }}>
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    sx={{ minHeight: '100vh' }}
                >
                    <Grid item xs={12} sm={10} md={8} lg={6}>
                        <Card elevation={4} sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
                            <CardContent>
                                <Box textAlign="center" mb={3}>
                                    <img
                                        src={failed_icon}
                                        alt="Payment Icon"
                                        style={{ maxWidth: '80px', marginBottom: '20px' }}
                                    />
                                    <Typography
                                        variant="h5"
                                        gutterBottom
                                        className="orderTitlet payFail"
                                    >
                                        Oops! Payment Failed
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        color="textSecondary"
                                        className="paymentID"
                                    >
                                        We couldn’t complete your payment.
                                    </Typography>
                                    <Typography
                                    variant="subtitle2"
                                        color="textSecondary"
                                        className="paymentID">
                                        Your payment could not be processed due to a technical issue. Please try again later or use a different payment method.


                                    </Typography>
                                </Box>

                                <Divider sx={{ my: 3 }} />

                                <Box
                                    display="flex"
                                    flexDirection={{ xs: 'column', sm: 'row' }}
                                    justifyContent="space-between"
                                    alignItems="center"
                                    mb={2}
                                    sx={{ gap: 2 }}
                                >
                                    <Typography
                                        variant="h6"
                                        className="planTxt"
                                        sx={{ textAlign: { xs: 'center', sm: 'left' } }}
                                    >
                                        {selectedPackage?.package_name} Plan for{' '}
                                        {selectedPackage?.valid_period} Months
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        className="planTxt"
                                        sx={{ textAlign: { xs: 'center', sm: 'right' } }}
                                    >
                                        ₹ {selectedPackage?.package_price}
                                    </Typography>
                                </Box>
                                <Box
                                    display="flex"
                                    flexDirection={{ xs: 'column', sm: 'row' }}
                                    justifyContent="space-between"
                                    alignItems="center"
                                    sx={{ gap: 2 }}
                                >
                                    <Typography
                                        variant="h6"
                                        className="planTxtYellow"
                                        sx={{ textAlign: { xs: 'center', sm: 'left' } }}
                                    >
                                        Total Price
                                    </Typography>
                                    <Typography
                                        variant="h6"
                                        className="planTxtYellow"
                                        sx={{ textAlign: { xs: 'center', sm: 'right' } }}
                                    >
                                        ₹ {selectedPackage?.package_price}
                                    </Typography>
                                </Box>
                                <Divider sx={{ my: 3 }} />

                                <Typography
                                    variant="h6"
                                    textAlign="center"
                                    className="queriesTxt"
                                >
                                    For any further queries
                                </Typography>
                                <Box
                                    display="flex"
                                    flexDirection={{ xs: 'column', sm: 'row' }}
                                    justifyContent="center"
                                    alignItems="center"
                                    gap={2}
                                    mt={1}
                                    sx={{ textAlign: 'center' }}
                                >
                                    <Typography variant="body1">
                                        <img
                                            src={payCallIcon}
                                            alt="Phone Icon"
                                            style={{
                                                verticalAlign: 'middle',
                                                marginRight: '8px',
                                            }}
                                        />
                                        +918600555740
                                    </Typography>
                                    <Typography variant="body1">
                                        <img
                                            src={payEmailIcon}
                                            alt="Email Icon"
                                            style={{
                                                verticalAlign: 'middle',
                                                marginRight: '8px',
                                            }}
                                        />
                                        support@indmatrimony.in
                                    </Typography>
                                </Box>

                                <Box textAlign="center" mt={4}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        href="/upgrade"
                                        size="large"
                                    >
                                        Try Again
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
};
